import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import { UserType, } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var QueueItemService = /** @class */ (function (_super) {
    tslib_1.__extends(QueueItemService, _super);
    function QueueItemService(http, _a) {
        var authConfig = _a.authConfig;
        var _this = _super.call(this, http, MapperService.queueItemMap) || this;
        _this.suggestReviewers = function (searchTerm, fetchSize, skip) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = {
                orderBy: ['UserName'],
                top: fetchSize,
                skip: skip,
                filter: {
                    UserName: {
                        startswith: searchTerm,
                    },
                    or: [
                        { Type: UserType[UserType.User] },
                        { Type: UserType[UserType.DirectoryUser] },
                    ],
                },
            };
            var endpoint = _this._endpoint + "/UiPath.Server.Configuration.OData.GetReviewers()";
            return _this._http
                .get("" + endpoint + _this.getQueryString(queryOptions))
                .pipe(map(function (response) { return _this._mapData(response, MapperService.userMap); }), map(function (_a) {
                var data = _a.data, total = _a.total;
                return ({
                    total: total,
                    data: data.map(function (user) { return ({
                        id: user.id,
                        text: user.userName,
                    }); }),
                });
            }));
        };
        _this._endpoint = authConfig.odataBaseUrl + "/QueueItems";
        return _this;
    }
    QueueItemService.prototype.getQueueItemHistory = function (itemId, queryOptions) {
        if (queryOptions.expand instanceof Array) {
            queryOptions.expand.push('Robot');
        }
        else {
            queryOptions.expand = ['Robot'];
        }
        return this.get(queryOptions, this._endpoint + "(" + itemId + ")/UiPathODataSvc.GetItemProcessingHistory");
    };
    QueueItemService.prototype.retryItems = function (itemIdentifiers) {
        var _this = this;
        var payload = JSON.stringify({
            'queueItems': itemIdentifiers.map(function (qi) { return _this._toPoco(qi, MapperService.queueItemIdentifierMap); }),
        });
        return this._http.post(this._endpoint + "/UiPathODataSvc.RetryQueueItem", payload)
            .pipe(map(function (res) { return _this._mapData(res, MapperService.bulkOperationMap); }));
    };
    QueueItemService.prototype.getItemLastRetry = function (itemId, expand) {
        var _this = this;
        if (expand === void 0) { expand = null; }
        var expansionList = expand === null ? '' : '?$expand=' + expand.join(',');
        return this._http
            .get(this._endpoint + "(" + itemId + ")/UiPath.Server.Configuration.OData.GetItemLastRetry()" + expansionList, {})
            .pipe(map(function (response) { return _this._mapData(response); }));
    };
    QueueItemService.prototype.changeItemReviewStatus = function (itemIdentifiers, status) {
        var _this = this;
        var payload = JSON.stringify({
            'queueItems': itemIdentifiers.map(function (qi) { return _this._toPoco(qi, MapperService.queueItemIdentifierMap); }),
            'status': status,
        });
        return this._http.post(this._endpoint + "/UiPathODataSvc.SetItemReviewStatus", payload)
            .pipe(map(function (res) { return _this._mapData(res, MapperService.bulkOperationMap); }));
    };
    QueueItemService.prototype.changeItemReviewer = function (itemIdentifiers, userId) {
        var _this = this;
        var payload;
        var action;
        if (userId) {
            action = 'UiPathODataSvc.SetItemReviewer';
            payload = JSON.stringify({
                'queueItems': itemIdentifiers.map(function (qi) { return _this._toPoco(qi, MapperService.queueItemIdentifierMap); }),
                'userId': userId,
            });
        }
        else {
            action = 'UiPathODataSvc.UnsetItemReviewer';
            payload = JSON.stringify({
                'queueItems': itemIdentifiers.map(function (qi) { return _this._toPoco(qi, MapperService.queueItemIdentifierMap); }),
            });
        }
        return this._http.post(this._endpoint + "/" + action, payload)
            .pipe(map(function (res) { return _this._mapData(res, MapperService.bulkOperationMap); }));
    };
    QueueItemService.prototype.deleteBulk = function (itemIdentifiers) {
        var _this = this;
        var payload = JSON.stringify({
            'queueItems': itemIdentifiers.map(function (qi) { return _this._toPoco(qi, MapperService.queueItemIdentifierMap); }),
        });
        return this._http.post(this._endpoint + "/UiPathODataSvc.DeleteBulk", payload)
            .pipe(map(function (res) { return _this._mapData(res, MapperService.bulkOperationMap); }));
    };
    QueueItemService.prototype.addQueueItem = function (item) {
        var payload = {
            itemData: this._toPoco(item, MapperService.queueItemDtoMap),
        };
        return this._http.post('/odata/Queues/UiPathODataSvc.AddQueueItem', JSON.stringify(payload));
    };
    QueueItemService.prototype.updateQueueItem = function (key, item) {
        var serverData = this._toPoco(item, MapperService.queueItemDtoMap);
        var content = JSON.stringify(serverData);
        return this._http
            .put(this._endpoint + "(" + key + ")", content, {
            headers: this._jsonHeaders,
        });
    };
    return QueueItemService;
}(ODataService));
export { QueueItemService };
